import { useMutation } from '@tanstack/react-query'
import { createOperatorTenant } from './api.js'

/**
 * No `invalidateQueries` — nothing in this console lists tenants the way the
 * roster page lists team members; the tenant switcher's own `useTenants()`
 * query is a separate, unrelated list this create doesn't feed, and nothing
 * on this screen keeps state past a single successful create.
 */
export function useCreateOperatorTenant() {
  return useMutation({ mutationFn: createOperatorTenant })
}
